import { userService } from '../../helpers/authservice/user.service';
import router from '../../router/index'
import { apiAuth } from '../../constants'
import axios from "axios";
import { disconnectSocket, connectSocket } from '../socket';
import store from '../store';
import { apiService } from '@/helpers/api.service';

const user = JSON.parse(localStorage.getItem('user'));
export const state = user ? { status: { loggeduser: true }, user } : { status: {}, user: null };

export const actions = {
    // Logs in the user.
    // eslint-disable-next-line no-unused-vars
    async login({ dispatch, commit }, { email, password }) {
        commit('loginRequest', { email });
        let urlAuth = `${apiAuth}/auth/login`

        await axios
            .post(urlAuth, {
                email: email,
                password: password,
            })
            .then(r => {
                return r.data
            })
            .then(res => {
                const role = res.data.user.role
                const isResto = role.includes('Administrador') || role.includes('Agente') || role.includes('Coordinador')
                
                if (isResto) {
                    userService.loginExtern(res)
                    
                    apiService.getMePermisions()
                    .then((rolesResponse) => {
                        if (rolesResponse) {
                            store.commit('setPermissions', rolesResponse.data.permissions);
                            return apiService.getStoreById().then(() => {
                                commit('loginSuccess', res);
                                router.push({path:'/welly/resto?title=Estos son tus wellys del día'}).catch(() => {});
                                return res;
                            });
                        } else {
                            throw new Error('Failed to get user roles');
                        }
                    });
                } else {
                    commit('loginFailure', res);
                    dispatch('notification/error', 'Usuario inválido', { root: true });
                    return Promise.reject('Usuario inválido');
                }
            }).catch((error) => {
                commit('loginFailure', error);
                dispatch('notification/error', error.response.data.message, { root: true });
            });
    },
    // Logout the user
    logout() {
        userService.logout();
        store.commit('setPermissions', []);
    },
    chkToken({ commit }) {
        let urlValidate = `${apiAuth}/api/validate/token`
        axios
            .get(urlValidate, {
                headers: { 'Authorization': "Bearer " + state.user.token },
            })
            .then(r => {
                return r.data
            })
            .then(() => {
                //token vivo
            })
            .catch(function (error) {
                // eslint-disable-next-line
                console.log(error)
                commit('logout');
                router.push({ path: '/login' })
            });
    },
    // register the user
    /*
    registeruser({ dispatch, commit }, user) {
        commit('registerRequest', user);
        userService.register(user)
            .then(
                user => {
                    commit('registerSuccess', user);
                    dispatch('notification/success', 'Registration successful', { root: true });
                    router.push('/login');
                },
                error => {
                    commit('registerFailure', error);
                    dispatch('notification/error', error, { root: true });
                }
            );
    }
    */
};

export const mutations = {
    loginRequest(state, user) {
        state.status = { loggingIn: true };
        state.user = user;
    },
    loginSuccess(state, user) {
        state.status = { loggeduser: true };
        state.user = user;
    },
    loginFailure(state) {
        state.status = {};
        state.user = null;
    },
    logout(state) {
        state.status = {};
        state.user = null;
    },
    /*
        registerRequest(state) {
            state.status = { registering: true };
        },
        registerSuccess(state) {
            state.status = {};
        },
        registerFailure(state) {
            state.status = {};
        }
        */
};

export function refreshToken() {
    setInterval(() => {
        if (localStorage.getItem('user')) {
            const token = JSON.parse(localStorage.getItem('refreshToken'));
            const url = `${apiAuth}/auth/refresh`
            axios
                .post(url, {}, {
                    headers: { 'Authorization': `Bearer ${token}` },
                })
                .then(r => {
                    return r.data
                })
                .then((res) => {
                    localStorage.setItem('authToken', JSON.stringify(res.data.tokens.accessToken));
                    localStorage.setItem('refreshToken', JSON.stringify(res.data.tokens.refreshToken));
                    disconnectSocket();
                    connectSocket();
                })
                .catch(() => {
                    window.location.href = '/login';
                });
        }
    }, 43200000);
}